import './goldeneagle/style';
import FormStructure from './goldeneagle/form_structure';

export default FormStructure;